import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    'ccInput',
    'messageInput',
    'suggestionBox',
    'suggestionText'
  ]
  
  static values = {
    suggestUrl: String,
    sendUrl: String,
    channel: String,
    leadId: Number
  }

  connect() {
    this.selectedChannel = this.channelValue || 'linkedin'
  }
  
  async generateSuggestion(event) {
    const button = event.currentTarget
    const originalText = button.innerHTML
    
    button.disabled = true
    button.innerHTML = '⏳ Generating...'
    
    try {
      const response = await fetch(this.suggestUrlValue, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': this.csrfToken
        },
        body: JSON.stringify({
          platform_type: this.selectedChannel
        })
      })
      
      const data = await response.json()
      
      if (data.success) {
        this.suggestionTextTarget.textContent = data.suggestion
        this.suggestionBoxTarget.classList.remove('hidden')
      } else {
        this.showError('Failed to generate suggestion: ' + (data.error || 'Unknown error'))
      }
    } catch (error) {
      console.error('Error generating suggestion:', error)
      this.showError('Error generating suggestion')
    } finally {
      button.disabled = false
      button.innerHTML = originalText
    }
  }
  
  useSuggestion() {
    const suggestion = this.suggestionTextTarget.textContent
    this.messageInputTarget.value = suggestion
    this.suggestionBoxTarget.classList.add('hidden')
  }
  
  async sendMessage(event) {
    const button = event.currentTarget
    const content = this.messageInputTarget.value.trim()
    
    if (!content) {
      this.showError('Please enter a message')
      return
    }
    
    button.disabled = true
    button.textContent = '📤 Sending...'
    
    try {
      const response = await fetch(this.sendUrlValue, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': this.csrfToken
        },
        body: JSON.stringify({
          platform_type: this.selectedChannel,
          message_content: content,
          ...(this.hasCcInputTarget && this.ccInputTarget.value.trim()
            ? { cc_emails: this.ccInputTarget.value.trim() }
            : {})
        })
      })
      
      const data = await response.json()
      
      if (data.success) {
        this.showSuccess('Message sent successfully! ✓')
        this.messageInputTarget.value = ''
        if (this.hasCcInputTarget) this.ccInputTarget.value = ''
        this.suggestionBoxTarget.classList.add('hidden')

        setTimeout(() => {
          Turbo.visit('/leads/inbox')
        }, 2000)
      } else {
        this.showError('Failed to send message: ' + (data.error || 'Unknown error'))
      }
    } catch (error) {
      console.error('Error sending message:', error)
      this.showError('Error sending message')
    } finally {
      button.disabled = false
      button.textContent = '📤 Send Message'
    }
  }
  
  get csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.content || ''
  }
  
  showSuccess(message) {
    const event = new CustomEvent('notification:show', {
      detail: { message, type: 'success' }
    })
    window.dispatchEvent(event)
  }
  
  showError(message) {
    const event = new CustomEvent('notification:show', {
      detail: { message, type: 'error' }
    })
    window.dispatchEvent(event)
  }
}

